module.exports = __webpack_public_path__ + "img/feature_buy_zh.22e743bc.png";